import { Slot, Style } from '@makeswift/runtime/controls'

export const props = {
	className: Style(),
	children: Slot()
}
